import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const SushyAds = ({})=> {

  const currentUser = security.currentUserValue;
  const apiKey      = '64ec8d36c9b87768126859';

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        style={{width:"100%", height:"92vh", border:0, padding:0, margin:0}}
        scrolling="yes"
        frameBorder="0"
        src={`https://offerwall.sushiads.com/wall?apiKey=${apiKey}&userId=${currentUser.id}`}
      ></iframe>
    </Fragment>
  );
};

export default SushyAds;
